import type { Client } from '@ooh/contracts';

export interface BrandRow {
  id: string;
  value: string;
}

interface ClientFormDefaults {
  acronym: string;
  brands: string[];
  name: string;
  notes: string | undefined;
}

export function createBrandRows(values: string[]): BrandRow[] {
  return values.map((value) => ({ id: crypto.randomUUID(), value }));
}

export function getClientFormDefaults(client?: Client): ClientFormDefaults {
  return {
    acronym: client?.acronym ?? '',
    brands: client?.brands ?? [],
    name: client?.name ?? '',
    notes: client?.notes ?? undefined,
  };
}

/**
 * Best-effort client-side mirror of the server's own suggestion rule
 * (upper-cased first letter of each word) — a live preview only, never
 * submitted unless the caller edits the acronym field themselves, so a
 * divergence from the server's actual suggestion is cosmetic
 * (offer-draft-numbering, task 4.2).
 */
export function deriveAcronymPreview(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');
}
